// js/state.js
// Global application state — shared between app.js and router.js.
// Mutated by app.js after Firebase Auth resolves; read by router.js guards.

/** @type {{ user: import('firebase/auth').User | null, profile: object | null }} */
export const appState = {
  user: null, // Firebase Auth user object
  profile: null, // Firestore user profile { role, name, email, ... }
  shop: null, // Active shop document if user is owner
  // Resolved customer shop slug — backed by sessionStorage so it survives
  // page reloads on localhost (where there is no subdomain to derive it from).
  shopSlug: sessionStorage.getItem("shopSlug") || null,
  // True while an owner is previewing their shop as a customer.
  // Persisted in sessionStorage so it survives in-page navigation.
  // Cleared only when the owner explicitly exits preview (navigates to /owner).
  ownerPreview: sessionStorage.getItem("ownerPreview") === "1",
};
